export default "__VITE_ASSET__C2nMhmM6__"